window.moment = require('moment')
window.axios = require('axios')


// WEBPACK FOOTER //
// ./src/globals.js